import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-144496d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg p-b-x16 departure-board-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "context-err"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "context-err__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-warning" })
], -1 /* HOISTED */))
const _hoisted_4 = {
  key: 0,
  class: "departure-board",
  "data-departure-board": ""
}
const _hoisted_5 = { class: "departure-board__title" }
const _hoisted_6 = {
  key: 0,
  class: "departure-board__intro"
}
const _hoisted_7 = { class: "departures-wrap" }
const _hoisted_8 = {
  key: 0,
  class: "departure-board__no-results"
}
const _hoisted_9 = {
  key: 1,
  class: "departure-board__last-updated"
}

import { onMounted, onUnmounted, ref, computed, PropType, inject } from 'vue'
import DeparturesService from '../../services/departures-service'
import { Terminal } from './../../types/enums'
import { AppSettingsKey } from './../../types/keys'
import type {
  AppSettings,
  DepartureBoards,
  DepartureSettings,
} from '../../types/'
import { handleLoadingState } from './../../utilities/async-helper'
import { getLocaleDateWithTimeZone } from '../../utilities/date-helper'
import { getCurrentCulture } from './../../utilities/culture-helper'
import DepartureSearch from './DepartureSearch.vue'
import DeparturesList from './DeparturesList.vue'
import LoadingWrapper from '../shared/LoadingWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeparturesBoard',
  props: {
  terminal: {
    type: String as PropType<Terminal>,
    required: true,
  },
  maxResults: {
    type: Number,
    default: 9,
  },
},
  setup(__props) {

const props = __props

const { apiBaseUrl, resourceStrings } = inject(AppSettingsKey) as AppSettings

const loadingState = ref<boolean>(true)
const mounted = ref<boolean>(false)
const errorState = ref<boolean>(false)
const pauseMainRefesh = ref<boolean>(false)
const currentCulture = getCurrentCulture()
const currentFilter = ref<string | null>(null)
const departuresService = new DeparturesService(apiBaseUrl)

const refreshSeconds = computed<number>(
  () => settings.value?.refreshRateSeconds || 10
)

const hasDepartures = computed<boolean>(() => {
  if (departureBoards.value?.departures) {
    return departureBoards.value.departures.length > 0
  }
  return false
})

let mainRefreshInterval: number
let filterRefreshInternal: number
let departureBoards = ref<DepartureBoards>()
let settings = ref<DepartureSettings | null>()

async function fetchDepartures(): Promise<void> {
  await handleLoadingState(loadingState, errorState, async () => {
    const departuresResponse = await departuresService.GetDepartures(
      props.terminal,
      props.maxResults
    )
    settings.value = departuresResponse.settings
    departureBoards.value = departuresResponse.departureBoards
  })
}

async function searchDepartures(): Promise<void> {
  await handleLoadingState(loadingState, errorState, async () => {
    const departureSearchResult = await departuresService.SearchDepartures(
      props.terminal,
      currentFilter.value || ''
    )
    if (departureSearchResult) {
      departureBoards.value = departureSearchResult
    } else {
      // API down?
      console.error(
        'Departures search endpoint returned a null or empty response. API may be down.'
      )
    }
  })
}

onMounted(async () => {
  await fetchDepartures()
  mounted.value = true

  // Refresh the main departure boards list
  mainRefreshInterval = window.setInterval(async () => {
    if (!pauseMainRefesh.value) {
      await fetchDepartures()
    }
  }, refreshSeconds.value * 1000)

  // Refresh filtered results if applicable
  filterRefreshInternal = window.setInterval(async () => {
    if (currentFilter.value && pauseMainRefesh.value) {
      await searchDepartures()
    }
  }, refreshSeconds.value * 1000)
})

onUnmounted(() => {
  clearInterval(mainRefreshInterval)
  clearInterval(filterRefreshInternal)
})

async function handleDepartureSearch(term: string): Promise<void> {
  // halt main timer, store ref to term and kick off search
  pauseMainRefesh.value = true
  currentFilter.value = term

  // Kick off a search
  await searchDepartures()
}

async function handleDepartureSearchCleared(): Promise<void> {
  // Reset flags/state
  pauseMainRefesh.value = false
  currentFilter.value = null

  // Re-fetch main listing
  await fetchDepartures()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (errorState.value && !_unref(departureBoards))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_unref(resourceStrings)['TravelUpdates.Departures.ApiErrorMessage']), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(LoadingWrapper, {
      loading: !mounted.value
    }, {
      default: _withCtx(() => [
        (_unref(settings))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_unref(settings).enabled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(settings).title[_unref(getCurrentCulture)(false).cultureShortCode]), 1 /* TEXT */),
                    (
              _unref(settings).introduction[_unref(getCurrentCulture)(false).cultureShortCode]
            )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(settings).introduction[_unref(getCurrentCulture)(false).cultureShortCode]), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true),
                    (_unref(departureBoards)?.showDepartureBoards)
                      ? (_openBlock(), _createBlock(DepartureSearch, {
                          key: 1,
                          onOnDepartureSearch: handleDepartureSearch,
                          onOnSearchCleared: handleDepartureSearchCleared
                        }))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_7, [
                (_unref(settings).enabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!hasDepartures.value && currentFilter.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_unref(resourceStrings)[
                  'TravelUpdates.SearchResults.SorryNoMatchesPrefix'
                ]) + " ", 1 /* TEXT */),
                            _createElementVNode("strong", null, _toDisplayString(currentFilter.value), 1 /* TEXT */),
                            _createTextVNode(". " + _toDisplayString(_unref(resourceStrings)[
                  'TravelUpdates.SearchResults.SorryNoMatchesSuffix'
                ]), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true),
                      (
                _unref(departureBoards)?.lastUpdatedVisible &&
                _unref(departureBoards)?.showDepartureBoards
              )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(resourceStrings)['TravelUpdates.Labels.LastUpdated']) + ": " + _toDisplayString(_unref(getLocaleDateWithTimeZone)(_unref(departureBoards).lastUpdated)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (
                _unref(departureBoards)?.showDepartureBoards &&
                _unref(departureBoards)?.departures
              )
                        ? (_openBlock(), _createBlock(DeparturesList, {
                            key: 2,
                            "current-culture": _unref(currentCulture),
                            departures: _unref(departureBoards).departures,
                            settings: _unref(settings)
                          }, null, 8 /* PROPS */, ["current-culture", "departures", "settings"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading"])
  ]))
}
}

})